import { Input } from 'antd';
import { useRef, useState } from 'react';
import { Check, Edit03, XClose } from '@insight-health-ai/roseate/icons';

export type EditableFieldProps = {
  children?: React.ReactNode;
  text?: string;
  onSave: (value: string) => void;
};

export const EditableField = ({
  children,
  text,
  onSave,
}: EditableFieldProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState(text);

  const handleSave = () => {
    onSave(value || '');
    setIsEditing(false);
  };

  const handleCancel = () => {
    setValue(text);
    setIsEditing(false);
  };

  return (
    <div ref={wrapperRef} className="flex items-center gap-1">
      {isEditing ? (
        <div className="flex items-center gap-1">
          <Input
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
            onBlur={() => {}}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSave();
              }
            }}
            className="h-[28px]"
          />
          <Check
            className="ml-1 w-5 h-5 cursor-pointer text-green-600 hover:text-green-700 font-bold"
            onClick={handleSave}
          />
          <XClose
            className="w-5 h-5 cursor-pointer text-red-600 hover:text-red-700 font-bold"
            onClick={handleCancel}
          />
        </div>
      ) : (
        <div className="flex items-center gap-1">
          {children || text}
          <Edit03
            onClick={() => {
              setIsEditing(true);
              setValue(text || '');
            }}
            className="cursor-pointer"
          />
        </div>
      )}
    </div>
  );
};
